import { useState } from 'react'
import { Button, TableCell, TableRow } from '@material-ui/core'
import { hasMemberCs } from '../helper'
import styles from '../styles/styles'
import { DialogCoownerDetail } from './DialogCoownerDetail'

export const ItemList = ({ coowner, refresh }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      {isDialogOpen && (
        <DialogCoownerDetail
          coownerDetail={coowner}
          refresh={refresh}
          closeDialog={() => {
            setIsDialogOpen(false)
          }}
        />
      )}
      <TableRow style={styles.tableRow}>
        <TableCell component="th" scope="coowner">
          {coowner.libelle} {hasMemberCs([coowner.type]) ? '*' : ''}
        </TableCell>
        <TableCell>
          {coowner?.lot ? `Lot ${coowner?.lot.numero}` : ''}
        </TableCell>
        <TableCell align="left">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setIsDialogOpen(true)
            }}
          >
            Voir les contacts
          </Button>
        </TableCell>
      </TableRow>
    </>
  )
}
